import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { bool, number, object, string } from "prop-types";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";

import { getAuthorName, multiAuthorSeperator, showSpecificNumOfWord } from "../../utils/utils";

import "./authorDetails.m.css";

const AuthorDetails = ({
  story = {},
  withAvatar = true,
  contributorType = 4,
  authorDetailsType = "",
  location = true,
  lang,
  dataAuthor = false,
  scrollIndex = 0,
}) => {
  const authorName = getAuthorName(story);
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);

  const authorLocation = get(story, ["metadata", "author-location"], "").trim();
  const authors = story.authors || [];
  const author = authors?.[0] || {};
  const { bio: authorBio = "", "contributor-role": contributorRole } = author;
  const { name: roleName = "" } = contributorRole || {};

  const isPublicAuthor = roleName === "Public Author";

  return (
    <div styleName="base">
      <div
        className={`author-details ${isPublicAuthor && authors.length === 1 ? "author-image" : "no-author-image"}`}
        styleName={authorDetailsType}
      >
        {isPublicAuthor && authors.length === 1 && !authorDisplayName && (
          <ContributorImage role={roleName} defaultImage={withAvatar} authorObj={author} />
        )}
        {authorDisplayName && (
          <ContributorImage
            role={roleName}
            defaultImage={withAvatar}
            authorDisplayName={authorDisplayName}
            authorObj={author}
          />
        )}

        <div className="author-name-location-wrapper">
          <div styleName="authors-list" className="print-authors-list">
            {!authorDisplayName && authors.length > 0 ? (
              authors.map((item, index) => (
                <Contributor
                  key={index}
                  name={item?.name}
                  dataAuthor={dataAuthor}
                  scrollIndex={scrollIndex}
                  seperator={multiAuthorSeperator(authors, lang, index)}
                  contributorType={contributorType}
                  authorObj={item}
                  authorLocationForStory={authorLocation}
                />
              ))
            ) : (
              <Contributor
                name={authorName}
                dataAuthor={dataAuthor}
                scrollIndex={scrollIndex}
                contributorType={contributorType}
                authorObj={author}
                authorDisplayName={authorDisplayName}
                authorLocationForStory={authorLocation}
              />
            )}
          </div>

          {location && authorLocation && (
            <span className="author-location" styleName="author-location">
              {authorLocation}
            </span>
          )}

          {authors.length === 1 && authorBio && isPublicAuthor && (
            <span className="author-bio" styleName="author-bio">
              {showSpecificNumOfWord(authorBio)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

AuthorDetails.propTypes = {
  story: object,
  withAvatar: bool,
  contributorType: number,
  authorDetailsType: string,
  location: bool,
  lang: string,
  dataAuthor: bool,
  scrollIndex: number,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
});

export default connect(mapStateToProps)(AuthorDetails);
